import { ListItem, ListItemText, Typography } from '@material-ui/core';

const ListItemComponent = ({ classNameListItem, label }) => (
  <ListItem className={classNameListItem || ''} disableGutters={true}>
    {label?.map((listItem, index) => (
      <ListItemText key={index} className={listItem.classname || ''}>
        <Typography
          variant={listItem.variant}
          className={listItem.typographyClass || ''}
        >
          {listItem.label}
        </Typography>
      </ListItemText>
    ))}
  </ListItem>
);

export default ListItemComponent;
